import { useState } from "react"
import { Modal, Button, Form } from "react-bootstrap"
import Select from "react-select"

// 🔹 Static dropdown options
const patientOptions = [
  { value: "rahul_mehta", label: "Rahul Mehta" },
  { value: "sophia_turner", label: "Sophia Turner" },
  { value: "liam_johnson", label: "Liam Johnson" },
  { value: "isabella_green", label: "Isabella Green" },
  { value: "lucas_brown", label: "Lucas Brown" },
  { value: "ava_white", label: "Ava White" },
  { value: "michael_johnson", label: "Michael Johnson" },
  { value: "jane_smith", label: "Jane Smith" },
  { value: "alice_brown", label: "Alice Brown" },
  { value: "ajay_johnson", label: "Ajay Johnson" },
]



const karmaOptions = [
  { value: "Virechan", label: "Virechan" },
  { value: "Vaman", label: "Vaman" },
  { value: "Basti", label: "Basti" },
  { value: "Nasya", label: "Nasya" },
  { value: "Raktamokshana", label: "Raktamokshana" },
]

const therapistOptions = [
  { value: "Dr.Shyam", label: "Dr.Shyam" },
  { value: "Dr.Vivek", label: "Dr.Vivek" },
  { value: "Dr.Ashok", label: "Dr.Ashok" },
  { value: "Dr.Mohan", label: "Dr.Mohan" },
]

const timeSlotOptions = [
  { value: "10:00-11:00", label: "10:00 AM - 11:00 AM" },
  { value: "11:00-12:00", label: "11:00 AM - 12:00 PM" },
  { value: "12:00-13:00", label: "12:00 PM - 01:00 PM" },
  { value: "13:00-14:00", label: "01:00 PM - 02:00 PM" },
  { value: "14:00-15:00", label: "02:00 PM - 03:00 PM" },
  { value: "15:00-16:00", label: "03:00 PM - 04:00 PM" },
  { value: "16:00-17:00", label: "04:00 PM - 05:00 PM" },
  { value: "17:00-18:00", label: "05:00 PM - 06:00 PM" },
];


const modeOptions = [
  { value: "offline", label: "Offline" },
  { value: "online", label: "Online" },
]

const CreateAppointmentModal = ({ show, handleClose, handleSaveAppointment, selectedDate, selectedRoom }) => {
  const [patient, setPatient] = useState(null)
  const [karma, setKarma] = useState(null)
  const [therapist, setTherapist] = useState(null)
  const [mode, setMode] = useState(modeOptions[0]) // default offline
  const [timeSlot, setTimeSlot] = useState(null)
  const [room, setRoom] = useState(selectedRoom || null)
  const handleSubmit = () => {
    handleSaveAppointment({
      date: selectedDate,
      patient: patient?.value || "",
      karma: karma?.value || "",
      therapist: therapist?.value || "",
      mode: mode?.value || "",
      room: room || "",
      timeSlot: timeSlot?.value || "",
    })
    handleClose()
  }
  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Create Appointment for {formatDateDDMMYYYY(selectedDate)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Patient</Form.Label>
            <Select options={patientOptions} value={patient} onChange={setPatient} placeholder="Select Patient" />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label> Karma</Form.Label>
            <Select options={karmaOptions} value={karma} onChange={setKarma} placeholder="Select Karma" />
          </Form.Group>
          <Form.Group className="mb-3">
  <Form.Label>Room</Form.Label>
  <Select
    options={[
      { value: "Room 1", label: "Room 1" },
      { value: "Room 2", label: "Room 2" },
    ]}
    value={room ? { value: room, label: room } : null}   // ✅ use local state
    onChange={(option) => setRoom(option.value)}         // ✅ update local state
    placeholder="Select Room"
  />
</Form.Group>



          <Form.Group className="mb-3">
            <Form.Label>Therapist</Form.Label>
            <Select options={therapistOptions} value={therapist} onChange={setTherapist} placeholder="Select Therapist" />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Mode</Form.Label>
            <Select options={modeOptions} value={mode} onChange={setMode} placeholder="Select Mode" />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Time Slot</Form.Label>
            <Select options={timeSlotOptions} value={timeSlot} onChange={setTimeSlot} placeholder="Select Time Slot" />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>

        <Button variant="primary" onClick={handleSubmit}>
          Book Appointment
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CreateAppointmentModal
